<template>
    <div id="deviceFlowReport">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="设备信息管理" C2Mname="流路折线图" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form label-position="right" inline class="device-from" label-width="120px">
                    <el-form-item label="设备名称：">
                        <span>{{deviceInfo.deviceName}}</span>
                    </el-form-item>
                    <el-form-item label="设备编号：">
                        <span>{{deviceInfo.deviceNickCode}}</span>
                    </el-form-item>
                    <el-form-item label="所在媒体编号：">
                        <span>{{deviceInfo.lightBoxCode}}</span>
                    </el-form-item>
                    <el-form-item label="所属站点：">
                        <span>{{deviceInfo.siteName}}</span>
                    </el-form-item>
                    <el-form-item label="绑定：">
                        <span>{{deviceInfo.bindtype}}</span>
                    </el-form-item>
                </el-form>
            </template>
        </HrrMainCardLayout>
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="form">
                    <el-form-item label="时间段：">
                        <el-date-picker v-model="form.beginTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="form.endTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button type="info" @click="Return()">返 回</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <!--<el-checkbox-group v-model="form.MtypeArr" size="mini">
                    <el-checkbox-button v-for="m in Mtype" :label="m.MtypeCode" :key="m.MtypeCode">{{m.MtypeName}}</el-checkbox-button>
                </el-checkbox-group>-->
            </template>
            <template slot="table">
                <ve-line :data="chartData" :loading="loading" :extend="extend" :after-config="afterconfig" :data-zoom="chartDataZoom" :data-empty="nodata"></ve-line>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'Device_Flow_Report',
    data() {
        this.extend = {
            yAxis: {
                axisLabel: {
                    color: "#fff"
                }
            },
            xAxis: {
                axisLabel: {
                    color: "#fff"
                }
            },
            series: {
                type: 'line',
                label: {
                    color: "rgba(181, 32, 32, 1)"
                }
            },
            legend:{
                textStyle:{
                     color:"#fff"
                }
            }
        };
        this.chartDataZoom = [{ type: 'slider' }];
        return {
            form: {
                deviceCode: "",
                beginTime: "",
                endTime: "",
                MtypeArr: []
            },
            chartData: {},
            returnPath: "",
            deviceInfo: [],
            loading: false,
            nodata:false,
            Mtype: [{ MtypeCode: "E01", MtypeName: "亮度" }, { MtypeCode: "L01", MtypeName: "电流" }, { MtypeCode: "D01", MtypeName: "异常" }]
        }
    },
    methods: {
        onSubmit() {
            this.initData();
        },
        initData() {
            this.deviceInfo = this.$route.meta.row;
            this.form.deviceCode=this.deviceInfo.deviceCode;
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.post(this.$api.MultiflowData.getMFDbyDeviceCode,this.form)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        if(data.Data.rows.length==0){
                            Vuethis.nodata=true;
                        }
                        Vuethis.chartData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        Return() {
            this.$router.push({ path: this.returnPath });
        },
        afterconfig(options) {
            return options;
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.searchform = from.meta.searchform;
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.returnPath = from.path;
        })
    },
    created() {
        this.initData();
    }
};
</script>
<style>
#deviceFlowReport .device-from .el-form-item__label {
    font-size: 14px !important;
    font-weight: bold;
    color: #4a65fb;
}

#deviceFlowReport .device-from .el-form-item__content {
    font-size: 14px !important;
}

#deviceFlowReport .device-from .el-form-item {
    margin-bottom: 0;
}
</style>